import { Box, CircularProgress } from "@mui/joy";
import { colorTokens } from "styles/globalStyles";

/** Semi-opaque blocker + spinner while an excursion planning drop is persisting. */
export default function ExcursionDropPendingOverlay({ show }: { show: boolean }) {
  if (!show) {
    return null;
  }

  return (
    <Box
      sx={{
        position: "absolute",
        inset: 0,
        zIndex: 10,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "inherit",
        bgcolor: "rgba(0, 0, 0, 0.42)",
        pointerEvents: "auto",
      }}
      aria-busy
      aria-label="Enregistrement en cours"
    >
      <CircularProgress
        size="md"
        sx={{
          "--CircularProgress-trackColor": colorTokens.border.default,
          "--CircularProgress-progressColor": colorTokens.accent.primary,
        }}
      />
    </Box>
  );
}
